import React from "react";
import {Button, Col, Form, FormInstance, message, Row, Switch, TreeSelect} from "antd";
import {observer} from "mobx-react";
import Input from "antd/es/input/Input";
import styled from "styled-components";
import {useStore} from "../../store";
import {UserOperationType} from "../../entity/enum/manager";
import {LoginInfoEntity} from "../../entity/login-info-entity";
import {addUserApi, editUserApi} from "../../http/manager";

interface UseModalProps {
    onSuccess?: () => void;
    form: FormInstance
}

const {SHOW_PARENT} = TreeSelect;

const UserModal: React.FC<UseModalProps> = ({onSuccess, form}) => {


    const {userInfoStore} = useStore();
    const {menuInfoList} = userInfoStore
    const setUserName = (e: any) => {
        if (!userInfoStore.useEditInfo) {
            userInfoStore.useEditInfo = new LoginInfoEntity();
        }
        userInfoStore.useEditInfo.username = e.target.value;
    }
    const setUserAccount = (e: any) => {
        if (!userInfoStore.useEditInfo) {
            userInfoStore.useEditInfo = new LoginInfoEntity();
        }
        userInfoStore.useEditInfo.useraccount = e.target.value;
    }
    const setUserTelephone = (e: any) => {
        if (!userInfoStore.useEditInfo) {
            userInfoStore.useEditInfo = new LoginInfoEntity();
        }
        userInfoStore.useEditInfo.telephone = e.target.value;
    }
    const setUserDepartment = (e: any) => {
        if (!userInfoStore.useEditInfo) {
            userInfoStore.useEditInfo = new LoginInfoEntity();
        }
        userInfoStore.useEditInfo.department = e.target.value;
    }
    const setUserPassword = (e: any) => {
        if (!userInfoStore.useEditInfo) {
            userInfoStore.useEditInfo = new LoginInfoEntity();
        }
        userInfoStore.useEditInfo.password = e.target.value;
    }

    const onButtonClick = () => {
        if (!userInfoStore.useEditInfo) {
            message.error("用户信息获取失败")
            return
        }
        if (!userInfoStore.useEditInfo?.username) {
            message.error("请输入人员姓名");
            return;
        }
        if (!userInfoStore.useEditInfo?.useraccount) {
            message.error("请输入账户");
            return;
        }
        if (!userInfoStore.useEditInfo?.telephone) {
            message.error("请输入联系方式");
            return;
        }
        if (!userInfoStore.useEditInfo?.department) {
            message.error("请输入部门名称");
            return;
        }
        if (userInfoStore.userType === UserOperationType.ADD && !userInfoStore.useEditInfo?.department) {
            message.error("请输入密码");
            return;
        }
        if (!userInfoStore || userInfoStore.menuKey.length <= 0) {
            message.error("请选择权限");
            return;
        }
        const params = new FormData();
        params.set("username", userInfoStore.useEditInfo.username);
        params.set("useraccount", userInfoStore.useEditInfo.useraccount);
        params.set("telephone", userInfoStore.useEditInfo.telephone);
        params.set("department", userInfoStore.useEditInfo.department);
        params.set("menuKey", userInfoStore.getMenuKey())
        params.set("selectMenuKey", userInfoStore.getSelectMenuKey())
        params.set("isAdmin", "0")
        if (userInfoStore.userType === UserOperationType.ADD) {
            params.set("password", userInfoStore.useEditInfo.password ? userInfoStore.useEditInfo.password : "");
        } else {
            params.set("id", String(userInfoStore.useEditInfo.id));
        }
        (userInfoStore.userType === UserOperationType.ADD ? addUserApi(params) : editUserApi(params))
            .then((res) => {
                if (Number(res.code) === 200) {
                    message.success(userInfoStore.userType === UserOperationType.ADD ? "新增成功" : "编辑成功");
                    if (onSuccess) {
                        onSuccess();
                    }
                } else {
                    message.error(userInfoStore.userType === UserOperationType.ADD ? "新增失败" : "编辑失败");
                }
            }).catch(() => {
            message.error(userInfoStore.userType === UserOperationType.ADD ? "新增失败" : "编辑失败");
        })
    }


    const onChange = (newValue: string[]) => {
        userInfoStore.menuKey = newValue
    };

    const tProps = {
        treeData: menuInfoList,
        value: userInfoStore.menuKey,
        onChange,
        treeCheckable: true,
        showCheckedStrategy: SHOW_PARENT,
        placeholder: '请选择',
        style: {
            width: '100%',
            autocomplete: "off"
        },
    };


    return (
        <Wrapper>
            <div style={{paddingBottom:"16px"}}>
                <Form form={form} title={"基础库编辑"} layout={"vertical"} size={"middle"}
                    style={{maxHeight: "450px", overflowY: "auto", overflowX: "hidden"}}>
                    <Row gutter={[16, 16]}>
                        <Col span={12}>
                            <Form.Item style={{marginBottom: "10px"}} name={"username"} label={"人员姓名"}><Input
                                autoComplete={'off'}
                                onChange={setUserName}
                                value={(userInfoStore.useEditInfo && userInfoStore.useEditInfo.username !== undefined) ? userInfoStore.useEditInfo.username : ""}
                                placeholder={"请输入"}/></Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item style={{marginBottom: "10px"}} name={"useraccount"} label={"登录账户"}><Input
                                autoComplete={'off'}
                                onChange={setUserAccount}
                                value={userInfoStore.useEditInfo && userInfoStore.useEditInfo.useraccount !== undefined ? userInfoStore.useEditInfo.useraccount : ""}
                                placeholder={"请输入"}/></Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item style={{marginBottom: "10px"}} name={"telephone"} label={"联系方式"}><Input
                                autoComplete={'off'}
                                onChange={setUserTelephone}
                                value={userInfoStore.useEditInfo && userInfoStore.useEditInfo.telephone ? userInfoStore.useEditInfo.telephone : ""}
                                type={"tel"} maxLength={11}
                                placeholder={"请输入"}/></Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item style={{marginBottom: "10px"}} name={"department"} label={"部门名称"}><Input
                                autoComplete={'off'}
                                onChange={setUserDepartment}
                                value={userInfoStore.useEditInfo && userInfoStore.useEditInfo.department ? userInfoStore.useEditInfo.department : ""}
                                placeholder={"请输入"}/></Form.Item>
                        </Col>
                        {userInfoStore.userType === UserOperationType.ADD && <Col span={12}>
                            <Form.Item name={"password"} style={{marginBottom: "10px"}} label={"登录密码"}><Input
                                autoComplete={'off'}
                                type={"password"}
                                onChange={setUserPassword}
                                value={userInfoStore.useEditInfo?.password}
                                placeholder={"请输入"}/></Form.Item>
                        </Col>}
                        <Col span={24}>
                            <Form.Item style={{marginBottom: "10px"}}
                                    label={"权限配置"}><TreeSelect {...tProps}/></Form.Item>
                        </Col>
                    </Row>
                </Form>
            </div>
            <Button onClick={onButtonClick} style={{marginTop: "30px"}}
                    type={"primary"}>{userInfoStore.userType === UserOperationType.ADD ? "新增" : "保存"}</Button>
        </Wrapper>
    );
}

export default observer(UserModal);

const Wrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    max-height: 400px;
    margin: 30px 0;
  }
`;